import React from "react";
import { Gift, Sparkles } from "lucide-react";

export const GiftRevealCard = () => (
  <div
    className="gg-gift-reveal relative overflow-hidden rounded-[16px] px-4 py-3.5 flex items-center gap-3.5"
    style={{
      background: "linear-gradient(120deg,#4A2C35 0%,#6B3E4C 55%,#4A2C35 100%)",
      border: "1px solid rgba(244,213,141,0.55)",
      boxShadow: "0 14px 28px -16px rgba(74,44,53,0.7)",
    }}
    data-testid="cart-free-gift-line"
  >
    <span className="gg-gift-shine pointer-events-none absolute inset-0" />
    <div className="relative w-12 h-12 flex-shrink-0">
      <span className="absolute inset-0 rounded-full gg-gift-glow" />
      <div
        className="relative w-12 h-12 rounded-full flex items-center justify-center"
        style={{ background: "linear-gradient(135deg,#F4D58D,#C5985A)" }}
      >
        <Gift size={20} className="text-plum gg-gift-lid" strokeWidth={2.2} />
      </div>
      <Sparkles size={12} className="absolute -top-1 -right-1 text-[#F4D58D] gg-sparkle-float" />
    </div>
    <div className="relative min-w-0 flex-1">
      <p className="text-[9px] tracking-[0.32em] uppercase font-semibold text-[#F4D58D]">
        Free Gift Unlocked
      </p>
      <p className="font-serif italic text-cream text-[15px] leading-tight mt-0.5">
        A surprise piece, packed with your Dream Box
      </p>
    </div>
    <span className="relative text-[11px] font-semibold tracking-[0.2em] text-[#F4D58D]" data-testid="cart-free-gift-price">
      ₹0
    </span>
  </div>
);

export default GiftRevealCard;
